import { useAtomValue } from 'jotai';
import { MapMarker } from '@/features/map';
import type { GlideMode } from '../model/types';
import { originAtom } from '../state/atoms';

const COLORS: Record<GlideMode, string> = { fly: '#d7191c', hike: '#1a9641' };

/** Takeoff (fly) or landing zone (hike) pin. */
export function OriginMarker() {
  const origin = useAtomValue(originAtom);
  if (!origin) return null;
  return <MapMarker key={origin.mode} lng={origin.lng} lat={origin.lat} color={COLORS[origin.mode]} />;
}
